// src/tasks/TaskManagement.jsx
import { useEffect, useState } from "react";
import api from "../../api";
import TaskForm from "./TaskForm";
import TaskTable from "./TaskTable";

const TaskManagement = () => {
  const [tasks, setTasks] = useState([]);

  const loadTasks = () => {
    api
      .get("/tasks/")
      .then(res => {
        // normalize response for paginated or non-paginated APIs
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.results ?? [];
        setTasks(data);
      })
      .catch(() => setTasks([]));
  };

  useEffect(() => {
    loadTasks();
  }, []);

  return (
    <>
      

      {/* Task creation form */}
      <TaskForm onCreated={loadTasks} />
      <h4 className="mb-4"> تسک‌های ایجاد شده</h4>

      {/* Task table */}
      <TaskTable tasks={tasks} onRefresh={loadTasks} />
    </>
  );
};

export default TaskManagement;
